import { dealStageProgress } from '../constants/dealStages';
import { type DealStageRow, inPipelineOrder } from '../hooks/useDealsStageFilter';
import { buildDealSwatchSvg } from '../utils/dealMarkerIcon';
import { ToggleChip } from './ToggleChip';

export function DealSwatch({ row, className }: { row: DealStageRow; className: string }) {
  return (
    <div
      className={`flex-shrink-0 [&>svg]:size-full ${className}`}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: SVG built from static templates, recolored
      dangerouslySetInnerHTML={{
        __html: buildDealSwatchSvg(row.style, dealStageProgress(row.stage)),
      }}
    />
  );
}

/** One chip per stage, in pipeline order, each swatch the same mark rendered on the map. */
export function DealStageChips({
  stages,
  onToggleStage,
}: {
  stages: DealStageRow[];
  onToggleStage: (stage: string) => void;
}) {
  return (
    <div className="flex flex-row flex-wrap gap-2">
      {inPipelineOrder(stages).map((row) => (
        <ToggleChip
          key={row.stage}
          label={row.stage}
          active={row.visible}
          onToggle={() => onToggleStage(row.stage)}
          swatch={<DealSwatch row={row} className="size-5" />}
        />
      ))}
    </div>
  );
}
